import { useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface FbResult {
  source: "og-scrape" | "apify";
  kind: "page" | "post" | "video";
  name: string;
  description: string | null;
  avatar: string | null;
  cover?: string | null;
  followers: number | null;
  likes?: number | null;
  verified?: boolean;
  url: string;
}

export const useFacebookSearch = () => {
  const [data, setData] = useState<FbResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const search = useCallback(async (url: string) => {
    setLoading(true);
    setError(null);
    setData(null);
    try {
      const { data: res, error: err } = await supabase.functions.invoke("facebook-search", { body: { url } });
      if (err) throw err;
      if ((res as any)?.error) throw new Error((res as any).error);
      setData(res as FbResult);
    } catch (e) {
      const msg = e instanceof Error ? e.message : "Lookup failed";
      setError(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => { setData(null); setError(null); }, []);

  return { data, loading, error, search, reset };
};
